import { QUANTUM_UI } from '../../../../flags';
import { FeedbackSection as FeedbackSectionNew } from './FeedbackSection';
import { FeedbackSection as FeedbackSectionOld } from './FeedbackSection.old';
export var FeedbackSection = QUANTUM_UI ? FeedbackSectionNew : FeedbackSectionOld;
